import React, { useEffect, useRef } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.jsx';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, login } = useAuth();
  const triedLoginRef = useRef(false);

  // Авто-логин в Telegram WebApp, если токена нет — но НЕ после ручного выхода
  // (флаг admin_logged_out), иначе «Выйти» сразу отменяется повторным входом.
  useEffect(() => {
    const isTelegram = Boolean(window.Telegram?.WebApp);
    const loggedOut = localStorage.getItem('admin_logged_out') === '1';
    if (!loading && !isAuthenticated && isTelegram && !loggedOut && !triedLoginRef.current) {
      triedLoginRef.current = true;
      const initData = window.Telegram.WebApp.initData || '';
      login(initData).catch(() => {});
    }
  }, [loading, isAuthenticated, login]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
